export default __webpack_public_path__ + "static/media/3.5afc8037.jpg";